<template>
  <div class="type-select px-2 mb-4">
    <div class="form-checkbox">
      <label dusk="filter-type-toggle" tabindex="0" class="flex items-center cursor-pointer w-full select-none focus:outline-none group text-yankFire">
        <input @change="handleChange" class="hidden" type="checkbox" value="type" v-model="enabled">
        <span
          class="mr-2 h-5 w-5 rounded border flex items-center justify-center transition duration-300"
          :class="{'text-yank border-aquamarine bg-aquamarine bg-opacity-25': isEnabled, 'border-platinum text-white group-hover:text-platinum group-hover:border-yank': ! isEnabled}"
        >
          <svg data-v-229d90a9="" aria-hidden="true" focusable="false" data-prefix="far" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-2.5 h-2.5 box-icon svg-inline--fa fa-check fa-w-16"><path fill="currentColor" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z" class=""></path></svg>
        </span>
        Media Type
      </label>
    </div>

    <ShowFilter :pose="isEnabled ? 'visible' : 'hidden'">
      <div class="filter-body px-1.5 mt-4">
        <div class="select cursor-pointer relative transition group text-sm">
          <select dusk="filter-type-select" class="border border-payneMiddle group-hover:border-yank w-full cursor-pointer h-11 transition duration-300 focus:outline-none select-none relative z-10 bg-transparent" v-model="selectedType">
            <option disabled :value="null">Choose An Option</option>
            <option value="graphic">Graphics</option>
            <option value="video">Videos</option>
            <option value="social-media">Social Media</option>
            <option value="photo">Photo</option>
            <option value="collection">Collection</option>
            <option value="sermon-kit">Sermon Kit</option>
          </select>
          <div class="icon absolute inset-y-0 right-0 w-11 flex items-center justify-center border-l border-payneMiddle group-hover:border-yank transition duration-300">
            <svg class="h-4 w-4 text-payneMiddle group-hover:text-yank transition duration-300" height="24" width="24" viewBox="0 0 24 24" version="1.1" xmlns:svgjs="http://svgjs.com/svgjs" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(1,0,0,1,0,0)"><path d="M 23.25,7.311L12.53,18.03c-0.292,0.293-0.767,0.293-1.059,0.001c0,0-0.001-0.001-0.001-0.001L0.75,7.311" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
          </div>
        </div>
      </div>
    </ShowFilter>
  </div>
</template>

<script>
  import posed from 'vue-pose'
  export default {
    props: {
      value: String,
      enabledFilters: Array,
    },

    components: {
      ShowFilter: posed.div({
        visible: {
          opacity: 1,
          height: `auto`,
          overflow: 'auto',
        },
        hidden: {
          opacity: 0,
          height: 0,
          overflow: 'hidden',
        }
      })
    },

    data() {
      return {
        enabled: this.enabledFilters,
        selectedType: this.value,
      }
    },

    computed: {
      isEnabled() {
        return this.enabled.includes('type')
      }
    },

    watch: {
      selectedType(type) {
        this.$emit('input', type)
      }
    },

    methods: {
      handleChange(event) {
        this.$emit('change', event)
      }
    }
  }
</script>
<style scoped>
  select {
    -webkit-appearance: none;
    padding: .5rem 3.25rem .5rem 1rem;
    box-sizing: border-box;
    border-radius: .5rem;
  }
</style>
